import {
  IconButton,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';

const ConsumptionsDataTable = ({ data, isLoading, onView }) => {
  return (
    <GeneralTableBox>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Número</HeadTableCell>
            <HeadTableCell>Orden técnica</HeadTableCell>
            <HeadTableCell>Depósito</HeadTableCell>
            <HeadTableCell>Fecha</HeadTableCell>
            <HeadTableCell>Estado</HeadTableCell>
            <HeadTableCell>Responsable</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : data && data.length > 0 ? (
            data.map((consumption) => (
              <TableRow key={consumption.uuid}>
                <RowTableCell>{consumption.consumption_number}</RowTableCell>
                <RowTableCell>{consumption.order_number}</RowTableCell>
                <RowTableCell>{consumption.warehouse_label}</RowTableCell>
                <RowTableCell>{consumption.created_at_label}</RowTableCell>
                <RowTableCell>
                  <Chip label={consumption.status_label} size="small" variant="outlined" />
                </RowTableCell>
                <RowTableCell>{consumption.responsible_label}</RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={0.5} justifyContent="center">
                    <Tooltip title="Ver detalle">
                      <IconButton size="small" onClick={() => onView?.(consumption)}>
                        <VisibilityIcon fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron consumos de stock" colSpan={7} />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default ConsumptionsDataTable;
